import React from "react";

interface PublicationProps {
  title: string;
  authors: string;
  image: string;
  description: string;
  link?: string;
}

const Publication: React.FC<PublicationProps> = ({
  title,
  authors,
  image,
  description,
  link,
}) => {
  return (
    <div className="flex flex-col md:flex-row items-start gap-6 mb-12">
      <div className="md:w-1/4 flex-shrink-0">
        {link ? (
          <a href={link} target="_blank" rel="noopener noreferrer">
            <img src={image} alt={title} className="w-full object-cover" />
          </a>
        ) : (
          <img src={image} alt={title} className="w-full object-cover" />
        )}
      </div>
      <div className="flex-1">
        <p className="text-gray-700 font-medium mb-2">{authors}</p>
        {link ? (
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-blue-700"
          >
            <h3 className="text-lg font-bold text-gray-800 mb-2">{title}</h3>
          </a>
        ) : (
          <h3 className="text-lg font-bold text-gray-800 mb-2">{title}</h3>
        )}
        <p className="text-gray-600">{description}</p>
      </div>
    </div>
  );
};

const Publications: React.FC = () => {
  const publications = [
    {
      title: "Delitos Sexuales, Tipicidad e Imputación Objetiva",
      authors: "Dr. Alfonso Montes Camelo & Dr. Andrés F. Soto Barrios",
      image: "/images/publicaciones/cover_issue_273_es_ES.jpg",
      description: "",
      link: "https://grupoeditorialibañez.com/product/delitos-sexuales-tipicidad-e-imputacion-objetiva/",
    },
    {
      title:
        "Conductas Punibles contra la Vida y la Integridad Personal: Últimas Jurisprudencias de las Cortes Constitucional y Suprema de Justicia",
      authors: "Dr. Alfonso Montes Camelo",
      image: "/images/publicaciones/conductas-punibles.png",
      description: "",
      link: "https://www.doctrinayley.com/tienda/libreria/derecho-penal/conductas-punibles-contra-la-vida-y-la-integrida-personal/",
    },
    {
      title: "La no Adecuación Típica del Punible de Desaparición Forzada",
      authors: "Dr. Alfonso Montes Camelo",
      image:
        "/images/publicaciones/la-no-adecuacion-tipica-del-punible-de-desaparicion-forzada.png",
      description: "",
      link: "https://www.doctrinayley.com/tienda/libreria/derecho-penal/la-no-adecuacion-tipica-del-punible-de-desaparicion-forzada/",
    },
    {
      title:
        "Las Garantías Judiciales y los Derechos Políticos en el Proceso Disciplinario Colombiano contra Funcionarios de Elección Popular",
      authors:
        "Dr. Andrés F. Soto Barrios, Dr. Diego Cardona Arbeláez & Alcides Peña Sánchez",
      image: "/images/publicaciones/cover_issue_33_es_ES.png",
      description: "",
      link: "https://revistas.unicartagena.edu.co/index.php/marioalariodfilippo/article/view/4256",
    },
    {
      title:
        "Excepción de Inconvencionalidad en las Actuaciones Públicas del Estado Colombiano",
      authors:
        "Dr. Andrés F. Soto Barrios, Dr. Alfonso Montes Camelo, Dra. Elina M. Meriño Ortega & Dr. Armando Noriega Ruiz",
      image:
        "/images/publicaciones/Captura+de+pantalla+2024-09-14+a+la(s)+12.29.05 p. m..png",
      description: "",
      link: "https://revistas.unicolmayor.edu.co/index.php/mjuridica/article/view/2383",
    },
    {
      title:
        "La Importancia de las Moot Courts en la Formación de los Abogados",
      authors: "Dr. Andrés F. Soto Barrios & Dra. Zlath Romero González",
      image: "/images/publicaciones/cover_issue_714_es_ES.png",
      description: "",
      link: "https://revistas.unilibre.edu.co/index.php/saber/article/view/10467",
    },
    {
      title:
        "Guía Metódica para un Análisis Jurisprudencial Constitucional: Ampliación de la Legalidad del Aborto en Colombia",
      authors: "Dr. Andrés F. Soto Barrios & Dra. Elina M. Meriño Ortega",
      image: "/images/publicaciones/cover_issue_664_es_ES.png",
      description: "",
    },
    {
      title: "¿Postconflicto o Conflicto Ardiente en Colombia?",
      authors: "Dr. Andrés F. Soto Barrios & Dra. Elina M. Meriño Ortega",
      image: "/images/publicaciones/cover_issue_693_es_ES.png",
      description: "",
      link: "https://revistas.unilibre.edu.co/index.php/revista_cultural/article/view/10889",
    },
    {
      title:
        "Influencia del Neoconstitucionalismo en la Configuración del Precedente Judicial en el Derecho Colombiano",
      authors:
        "Dr. Andrés F. Soto Barrios & Dr. Jesús Alberto Rodríguez Peniehe",
      image: "/images/publicaciones/cover_issue_708_es_ES.png",
      description: "",
    },
    {
      title:
        "El Dilema: La Desobediencia Civil o la Libertad Individual de Conciencia (Artículo 18 de la Constitución Nacional) entre el Iusnaturalismo y el Positivismo Jurídico",
      authors:
        "Dr. Alfonso Montes Camelo, Dr. Andres Alarcon Lora & Silvia Lozano",
      image: "/images/publicaciones/Imagen.jpeg",
      description: "",
    },
  ];

  return (
    <div className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-3xl font-medium uppercase mb-4">PUBLICACIONES</h1>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8">
          {publications.map((pub, index) => (
            <Publication
              key={index}
              title={pub.title}
              authors={pub.authors}
              image={pub.image}
              description={pub.description}
              link={pub.link}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Publications;
